
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ArtistVideoAdmin from '@/components/staff/ArtistVideoAdmin.vue'
import { RoomState } from '@/services/Seatings'
import { GuestList } from '@/services/Guests'

@Component({
  components: { ArtistVideoAdmin },
})
export default class ArtistVideoBox extends Vue {
  @Prop({ required: true }) public seatingId!: string
  @Prop({ required: true }) public roomId!: string
  @Prop({ required: true, default: false }) public muteSound!: boolean
  @Prop({ required: true, default: null }) public guests!: GuestList

  public roomState: RoomState | null = null
  public defaultVolume = 0
  public volume: number = this.defaultVolume
  public prevVolume: number = this.defaultVolume

  public muteForMe() {
    this.volume = 0
  }
  public unmuteForMe() {
    this.volume = 100
  }

  public youTubeReady() {
    this.handleVolume()
  }

  get videoId(): string {
    return this.roomState?.videoId ? this.roomState.videoId : ''
  }

  get isArtistVideoIsPlaying() {
    return this.roomState?.videoIsPlaying ? this.roomState.videoIsPlaying : false
  }

  get isFullscreenVideoIsPlaying() {
    return Object.keys(this.guests).reduce((result, guestId) => {
      const guest = this.guests[guestId]
      if (!guest) {
        return result
      }
      return result || !!guest.watchingVideoId
    }, false)
  }

  get isSameFullscreenVideoIsPlaying() {
    return Object.keys(this.guests).reduce((result, guestId) => {
      const guest = this.guests[guestId]
      if (!guest) {
        return result
      }
      return result || (!!guest.watchingVideoId && guest.watchingVideoId === this.videoId)
    }, false)
  }

  get videoIsPlaying(): boolean {
    return this.isArtistVideoIsPlaying || this.isSameFullscreenVideoIsPlaying
  }

  get anyOtherVideoIsPlaying(): boolean {
    return this.isFullscreenVideoIsPlaying && !this.isSameFullscreenVideoIsPlaying
  }

  @Watch('volume', { immediate: true })
  public handleVolume() {
    const youTubeRef = this.$refs.youtube as any
    const youTubePlayer = youTubeRef?.player
    if (youTubePlayer) {
      youTubePlayer.setVolume(this.volume)
    }
  }

  @Watch('videoIsPlaying')
  public handleVideoIsPlayingChange(videoIsPlaying: boolean) {
    const youTubeRef = this.$refs.youtube as any
    const youTubePlayer = youTubeRef?.player

    if (youTubePlayer) {
      if (this.isArtistVideoIsPlaying || this.isSameFullscreenVideoIsPlaying) {
        this.$nextTick(() => {
          youTubePlayer.playVideo()
        })
        return
      }

      youTubePlayer.stopVideo()
    }
  }

  @Watch('videoId')
  public handleVideoChange() {
    // For every change in video, put the volume back on
    this.volume = this.defaultVolume
  }

  @Watch('muteSound')
  public handleMuteSound() {
    if (this.muteSound) {
      this.prevVolume = this.volume
      this.muteForMe()
    } else {
      this.volume = this.prevVolume
    }
  }
}
